var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "not-found-container d-flex flex-row align-items-center" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "12", md: "6" } },
                [
                  _c("img", {
                    staticClass: "w-50",
                    attrs: {
                      src: require("@Shared/@Assets/img/something-went-wrong.svg"),
                      alt: _vm.$t("notification-messages.somethingWentWrong"),
                    },
                  }),
                  _vm._v(" "),
                  _c("h1", [_vm._v("OOPS!")]),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "notification-messages.notAbleToLoadInformation"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary mt-3",
                      attrs: { to: _vm.route },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("global.actions.takeMeBack")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }